// extracted by mini-css-extract-plugin
export default {"SuccesModalBodyContainer":"TNSuccessModal_SuccesModalBodyContainer__EwsFO","closeIcon":"TNSuccessModal_closeIcon__NEBDJ"};